import CreateBillingDocumentsWorkflow from '../../../../components/workflows/general/create-billing-documents-workflow';

/**
 * @ngdoc service
 * @name contacts.factories:createBillingDocuments
 *
 * @description
 *
 */
angular
    .module('festzelt-os.contacts')
    .factory('createBillingDocuments', [
        'Alert',
        '$http',
        '$uibModal',
        (Alert, $http, $uibModal) => new CreateBillingDocumentsWorkflow('contacts', Alert, $http, $uibModal)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/list-view/create-billing-documents.js